import { Controller } from "@hotwired/stimulus"
import { dsConfirm } from "../../utils/ds_confirm";

export default class extends Controller {
  static targets = ["selectAll", "item", "deleteBtn"]
  static values = {
    cleanHistoryLabel: String,
    deleteSelectionLabel: String,
    confirmDeleteAll: String,
    confirmDeleteSelection: String,
    bulkDeleteUrl: String
  }

  connect() {
    this.updateSelectAllState()
    this.updateDeleteButton()
  }

  toggleAll() {
    const isChecked = this.selectAllTarget.checked
    
    this.itemTargets.forEach(checkbox => {
      checkbox.checked = isChecked
    })
    
    this.updateSelectAllState()
    this.updateDeleteButton()
  }

  toggleItem() {
    this.updateSelectAllState()
    this.updateDeleteButton()
  }

  updateSelectAllState() {
    // An empty history renders no « select all » box.
    if (!this.hasSelectAllTarget) return

    const totalItems = this.itemTargets.length
    const checkedItems = this.itemTargets.filter(checkbox => checkbox.checked).length
    
    if (checkedItems === 0) {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = false
    } else if (checkedItems === totalItems) {
      this.selectAllTarget.checked = true
      this.selectAllTarget.indeterminate = false
    } else {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = true
    }
  }

  updateDeleteButton() {
    if (!this.hasDeleteBtnTarget) return

    const selectedCount = this.getSelectedCount()
    const totalCount = this.itemTargets.length
    
    if (selectedCount === 0 || selectedCount === totalCount) {
      // Aucune sélection ou tout sélectionné : bouton pour tout supprimer
      this.deleteBtnTarget.textContent = "🗑️ " + this.cleanHistoryLabelValue
      this.deleteBtnTarget.className = "px-4 py-2 text-sm bg-red-100 text-red-700 rounded-md hover:bg-red-200 transition-colors"
    } else {
      // Sélection partielle : bouton pour supprimer la sélection
      const label = this.deleteSelectionLabelValue.replace('%{count}', selectedCount)
      this.deleteBtnTarget.textContent = "🗑️ " + label
      this.deleteBtnTarget.className = "px-4 py-2 text-sm bg-orange-100 text-orange-700 rounded-md hover:bg-orange-200 transition-colors"
    }
  }

  async deleteSelected() {
    const selectedIds = this.getSelectedIds()
    const totalCount = this.itemTargets.length
    
    let confirmMessage, deleteAll = false
    
    if (selectedIds.length === 0 || selectedIds.length === totalCount) {
      // Aucune sélection ou tout sélectionné : supprimer tout
      confirmMessage = this.confirmDeleteAllValue.replace('%{count}', totalCount)
      deleteAll = true
    } else {
      // Sélection partielle : supprimer la sélection
      confirmMessage = this.confirmDeleteSelectionValue.replace('%{count}', selectedIds.length)
      deleteAll = false
    }
    
    if (await dsConfirm(confirmMessage, { tone: "danger" })) {
      // Créer un formulaire temporaire pour envoyer la requête DELETE
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = this.bulkDeleteUrlValue
      
      // Ajouter le token CSRF
      const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      const csrfInput = document.createElement('input')
      csrfInput.type = 'hidden'
      csrfInput.name = 'authenticity_token'
      csrfInput.value = csrfToken
      form.appendChild(csrfInput)
      
      // Ajouter la méthode DELETE
      const methodInput = document.createElement('input')
      methodInput.type = 'hidden'
      methodInput.name = '_method'
      methodInput.value = 'DELETE'
      form.appendChild(methodInput)
      
      if (deleteAll) {
        // Supprimer tout
        const deleteAllInput = document.createElement('input')
        deleteAllInput.type = 'hidden'
        deleteAllInput.name = 'delete_all'
        deleteAllInput.value = 'true'
        form.appendChild(deleteAllInput)
      } else {
        // Supprimer la sélection
        const idsInput = document.createElement('input')
        idsInput.type = 'hidden'
        idsInput.name = 'generation_ids'
        idsInput.value = selectedIds.join(',')
        form.appendChild(idsInput)
      }
      
      // Soumettre le formulaire
      document.body.appendChild(form)
      form.submit()
    }
  }

  getSelectedIds() {
    return this.itemTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)
  }

  getSelectedCount() {
    return this.itemTargets.filter(checkbox => checkbox.checked).length
  }
}
 